export const initialTickets = [
  {
    id: 'TKT-8902',
    subject: 'Critical: API Rate Limit Exceeded',
    customer: {
      name: 'Sarah Jenkins',
      company: 'TechFlow Inc.',
      avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=face',
      plan: 'Enterprise',
      sentiment: -0.8
    },
    status: 'open',
    priority: 'urgent',
    createdAt: '2023-10-27T09:15:00Z',
    slaDeadline: new Date(Date.now() + 1000 * 60 * 45).toISOString(),
    messages: [
      { id: 1, sender: 'customer', text: 'Our production services are failing due to 429 Too Many Requests errors. We are on the Enterprise plan and shouldn\'t be hitting limits. Please investigate immediately.', timestamp: '2023-10-27T09:15:00Z' },
      { id: 2, sender: 'system', text: 'Priority automatically upgraded to URGENT based on keywords [Critical, Production, Failing]. SLA adjusted to 1hr.', timestamp: '2023-10-27T09:15:05Z' }
    ],
    tags: ['api', 'production', 'billing']
  },
  {
    id: 'TKT-8901',
    subject: 'Cannot invite new team members',
    customer: {
      name: 'Marcus Chen',
      company: 'DesignStudio',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
      plan: 'Pro',
      sentiment: 0.2
    },
    status: 'pending',
    priority: 'normal',
    createdAt: '2023-10-27T08:30:00Z',
    slaDeadline: new Date(Date.now() + 1000 * 60 * 60 * 4).toISOString(),
    messages: [
      { id: 1, sender: 'customer', text: 'Hi team, I am trying to add a new designer to our workspace but the "Invite" button is greyed out. My billing is up to date.', timestamp: '2023-10-27T08:30:00Z' },
      { id: 2, sender: 'agent', text: 'Hi Marcus, I can help with that. Could you confirm if you are the Workspace Admin? Only admins can invite new members on the Pro plan.', timestamp: '2023-10-27T08:45:00Z' }
    ],
    tags: ['account', 'rbac']
  },
  {
    id: 'TKT-8895',
    subject: 'Feature Request: Dark Mode Export',
    customer: {
      name: 'Elena Rodriguez',
      company: 'Freelancer',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',
      plan: 'Starter',
      sentiment: 0.9
    },
    status: 'open',
    priority: 'low',
    createdAt: '2023-10-26T14:20:00Z',
    slaDeadline: new Date(Date.now() + 1000 * 60 * 60 * 24).toISOString(),
    messages: [
      { id: 1, sender: 'customer', text: 'Love the new app update! It would be amazing if we could export PDF reports in dark mode to match our internal branding.', timestamp: '2023-10-26T14:20:00Z' }
    ],
    tags: ['feature-request', 'ui']
  }
];

export const macros = [
  { id: 'm1', title: 'Reset Password', content: 'Hi {{name}}, you can reset your password by following this link: [Reset Link].' },
  { id: 'm2', title: 'Plan Upgrade Info', content: 'Thanks for inquiring about upgrading! Our Enterprise plan includes increased API limits.' },
  { id: 'm3', title: 'Apology - Downtime', content: 'We sincerely apologize for the recent service interruption. Our engineering team has identified the issue.' }
];

export const metrics = {
  csat: 94.2,
  avgResponseTime: '12m',
  openTickets: 42,
  resolvedToday: 128
};

export const demoWorkflowSteps = [
  { id: 1, title: 'Inbound Signal', description: 'AI detects sentiment and automatically categorizes the ticket based on severity.', icon: 'FiZap' },
  { id: 2, title: 'SLA Hardening', description: 'System assigns dynamic timers based on customer plan tier (Enterprise vs Starter).', icon: 'FiClock' },
  { id: 3, title: 'Agent Assignment', description: 'Cockpit routes the ticket to the agent with the highest skill-match for the tags.', icon: 'FiUserCheck' },
  { id: 4, title: 'Macro Synthesis', description: 'Suggested replies are generated from the Knowledge Base to reduce MTTR.', icon: 'FiCpu' },
  { id: 5, title: 'Resolution & CSAT', description: 'Closing the ticket triggers an automated feedback loop for satisfaction tracking.', icon: 'FiCheckCircle' }
];

export const demoSampleData = [
  { id: 'REC-001', name: 'Global CDN Lag', status: 'Resolved', date: '2023-10-27', agent: 'Agent 04', impact: 'High', note: 'Resolved via cache purge.' },
  { id: 'REC-002', name: 'Billing Discrepancy', status: 'Pending', date: '2023-10-27', agent: 'Agent 09', impact: 'Medium', note: 'Awaiting invoice copy.' },
  { id: 'REC-003', name: 'SSO Login Failure', status: 'Active', date: '2023-10-27', agent: 'Agent 01', impact: 'Urgent', note: 'Internal auth service down.' },
  { id: 'REC-004', name: 'UI Glitch - Safari', status: 'In Review', date: '2023-10-26', agent: 'Agent 04', impact: 'Low', note: 'Reported to dev team.' },
  { id: 'REC-005', name: 'API Key Rotation', status: 'Resolved', date: '2023-10-26', agent: 'Agent 12', impact: 'Medium', note: 'Security protocol met.' },
  { id: 'REC-006', name: 'Feature: Dark Mode', status: 'Pending', date: '2023-10-25', agent: 'Agent 02', impact: 'Low', note: 'Roadmap discussion.' },
];

export const faqData = [
  {
    q: "How does the Sentiment Glow system work?",
    a: "SupportNova uses real-time NLP to analyze the customer's language. If frustration levels exceed -0.6, the ticket border glows Priority Red to alert the agent of an impending escalation."
  },
  {
    q: "Is this data real or simulated?",
    a: "This is a high-fidelity simulation designed for demonstration purposes. All names, company profiles, and metrics are synthetic and generated for this workspace demo."
  },
  {
    q: "Can I connect my own CRM APIs to this demo?",
    a: "No, this is a standalone demo environment. In production, SupportNova integrates with Salesforce, HubSpot, and ZenDesk via our secure API gateway."
  },
  {
    q: "What are 'Macros' in the Cockpit view?",
    a: "Macros are pre-configured response templates that can be triggered with a '/' command, allowing agents to solve common issues in seconds."
  },
  {
    q: "How is privacy handled in this demo?",
    a: "Zero private data is stored. This environment operates entirely in your browser session for security and compliance testing."
  }
];